// import { CountryCode, parsePhoneNumberWithError } from "libphonenumber-js";

// Core validation functions
export const validators = {
  email: (value: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(value)
  },

  phone: (value: string): boolean => {
    // return validatePhoneNumber(value);
    return true
  },

  length: (value: string, min?: number, max?: number): boolean => {
    if (min !== undefined && value.length < min) return false
    if (max !== undefined && value.length > max) return false
    return true
  },

  required: (value: string): boolean => {
    return value.trim().length > 0
  },

  regex: (value: string, pattern: string): boolean => {
    const regex = new RegExp(pattern)
    return regex.test(value.trim())
  },
}

// function validatePhoneNumber(value: string) {
//     try {
//         if(!value) return false;

//         const phoneNumber = parsePhoneNumberWithError(value, country as CountryCode);
//         const isValid = phoneNumber.isValid()
//         return isValid;

//     } catch(err) {
//         return false;
//     }
// }
